import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box } from '@mui/material';
import { OrderFilter } from '../../interfaces/Order/OrderFilter';
import { getOrders } from '../../api/Order';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { Order } from '../../interfaces/Order/Order';
import { Pagination } from '../../interfaces/Pagination';
import { OrdersTable } from '../Order/OrdersTable/OrdersTable';
import { Waiting } from '../../components/Waiting/Waiting';

type AffiliateOrdersTableProps = {
  affiliateCode: string;
};

export const AffiliateOrdersTable = ({
  affiliateCode,
}: AffiliateOrdersTableProps) => {
  const [orders, setOrders] = useState<PaginatedResponse<Order>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState<OrderFilter>({
    pagination: { page: 0, pageSize: 10 },
  });
  const [loading, setLoading] = useState(false);

  const refreshOrders = () => {
    setLoading(true);
    getOrders({ ...filter, affiliateCode })
      .then((o) => {
        setOrders(o);
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOrders();
  }, [affiliateCode, filter]);

  const handlePagination = (p: Pagination) => {
    const newFilter: OrderFilter = { ...filter, pagination: p };

    setFilter(newFilter);
  };

  return (
    <Box>
      <Waiting open={loading} />

      <OrdersTable
        orders={orders.data}
        totalCount={orders.totalCount}
        pagination={filter.pagination}
        onPagination={handlePagination}
      />
    </Box>
  );
};
